// @ts-nocheck
const DEFAULT_STATE = {
	past: true,
	actual: true,
	future: true,
};

export default class ClosureSwitch extends SMap.Control.Visible {
	$constructor() {
		this._dom = {
			container: Mapy.Util.node("div", { className: "closureswitch map-control" }),
			past: Mapy.Util.buildRadioCheck("checkbox", undefined, "minulé"),
			actual: Mapy.Util.buildRadioCheck("checkbox", undefined, "současné"),
			future: Mapy.Util.buildRadioCheck("checkbox", undefined, "budoucí"),
		};

		this.setState({});

		this._build();
	}

	setState(state) {
		this._state = {
			...DEFAULT_STATE,
			...state,
		};
	}

	getState() {
		return {
			...this._state,
		};
	}

	handleEvent() {
		this.setState({
			past: this._dom.past.input.checked,
			actual: this._dom.actual.input.checked,
			future: this._dom.future.input.checked,
		});

		Mapy.getComponent("pois").updatePoiaggOpts({
			...this.getState(),
		});
		Mapy.getComponent("pois").forceRequest(true);
	}

	_build() {
		this._dom.container.appendChild(Mapy.Util.text("uzavírky: "));
		this._dom.container.appendChild(this._dom.past.label);
		this._dom.container.appendChild(this._dom.actual.label);
		this._dom.container.appendChild(this._dom.future.label);

		this._dom.past.input.checked = this._state.past;
		this._dom.actual.input.checked = this._state.actual;
		this._dom.future.input.checked = this._state.future;

		this._dom.past.input.addEventListener("change", this);
		this._dom.actual.input.addEventListener("change", this);
		this._dom.future.input.addEventListener("change", this);
	}
}
